import React from 'react';
type Tome = {
  number: string;
  cards: string;
  title: string;
  promise: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  cards: '26 cards',
  title: 'Build the Routine',
  promise: 'Pre-season, the practice routine and the fundamentals that carry to the first game.',
  badge: 'bg-turf',
  contents: ['The 4-Quarter Practice, set up for week one', 'The Station Rotation Grid so nobody stands around', 'The Huddle Reset for when you lose the group', 'A minute-by-minute first-practice script', 'A Rules-Check page to fit your league and format']
}, {
  number: '02',
  cards: '24 cards',
  title: 'The Offense Install',
  promise: 'Quarterback, center and the five base plays kids actually remember.',
  badge: 'bg-q3',
  contents: ['The Starter Five: the only plays you install first', 'Color-Code Play Cards for fast recall', 'The Route Ladder, simple to advanced', 'Quarterback and center, step by step', 'How to run it inside Q3 Team Install']
}, {
  number: '03',
  cards: '24 cards',
  title: 'The Defense Install',
  promise: 'Pursuit, flag-pulling, coverage and rush — defense kids can see.',
  badge: 'bg-q4',
  contents: ['The Flag Angle Rule for clean flag pulls', 'The Rush Lane Map so nobody runs out of the play', 'Zone Boxes: coverage made visible', 'Pursuit and leverage drills', 'The tackle-vs-flag version of each']
}, {
  number: '04',
  cards: '24 cards',
  title: 'Youth Tackle Fundamentals',
  promise: 'Blocking, ball security and progressive contact — inside your league’s rules.',
  badge: 'bg-q1',
  contents: ['The Contact Ladder, progressive and age-appropriate', 'The 3-Point Squeeze for blocking', 'The Eyes-Up Rule for ball security', 'Footwork before any contact', 'Follow your league’s rules and certification throughout']
}, {
  number: '05',
  cards: '20 cards',
  title: 'The Game-Week Loop',
  promise: 'Game weeks, game day, rain-outs and short days — and the season send-off.',
  badge: 'bg-[#6C4AB6]',
  contents: ['The Game-Week Loop: install, rep, script, play', 'The Practice Script for the week of the game', 'The Fair-Play Rotation Chart parents can see', 'Game-day roles and the sideline', 'Rain, short days and no-show days, handled']
}, {
  number: '06',
  cards: '24 cards',
  title: 'The Competitive Edge',
  promise: 'For teams ready for more: 7v7 concepts, QB reads and situations.',
  badge: 'bg-[#12858A]',
  contents: ['The Read Ladder: teaching the QB to read', '7v7 concepts and spacing', 'Zone and man coverage situations', 'The 2-Minute Practice for end-of-game', 'The Fresh Rule to keep legs and focus']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-white" data-id="element-285" data-mp="wn9yqncoicf4">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-286" data-mp="11lbjdcpr6jsp">
        <div className="text-center" data-id="element-287" data-mp="11jqpzqf6d6wf">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-288" data-mp="16kxxdodeo42k">
            142 Practice Cards, ready to print and run
          </p>
          <h2 id="tomes-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-289" data-mp="1algpzkn4he5t">
            Inside the system — six volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-290" data-mp="ispujcd9jthm">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col rounded-2xl border border-ice-dark bg-white p-6 shadow-card" data-id="element-291" data-mp="rndz10b0l75d">
              <div className="flex items-center gap-2.5" data-id="element-292" data-mp="3ranbu0a75nuq">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg font-display text-lg text-white ${tome.badge}`} data-id="element-293" data-mp="3vbpb2h445zwp">
                  {tome.number}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-294" data-mp="37ac7vw9q5jgr">
                  Volume {tome.number}
                </span>
                <span className="ml-auto rounded-full bg-ice px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-ink-soft" data-id="element-295" data-mp="3h6f7aud6z400">
                  {tome.cards}
                </span>
              </div>
              <h3 className="mt-3 text-lg font-bold leading-snug text-ink" data-id="element-296" data-mp="3q01zybm3rr4z">
                {tome.title}
              </h3>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-297" data-mp="8pu4xwf2f95v">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-ice-dark pt-4" data-id="element-298" data-mp="3rsqxpwhy019">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-299" data-mp="2aj1wq5bv7j8n">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-300" data-mp="25kgww70iz1kq" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}